import { render } from "./payzen_payment.vue?vue&type=template&id=665b0e27&scoped=true"
import script from "./payzen_payment.vue?vue&type=script&lang=js"
export * from "./payzen_payment.vue?vue&type=script&lang=js"

import "./payzen_payment.vue?vue&type=style&index=0&id=665b0e27&scoped=true&lang=css"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\_VELO\\demo-location.accen.me\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665b0e27"]])

export default __exports__